export default __webpack_public_path__ + "static/media/arrow-down-disabled.e9758fe4.svg";